export const appVersion = '1.2.12';